import RestaurantList from './list';

export type { RestaurantListProps } from './list';

export default RestaurantList;
